import React from 'react';
import Loader from './Loader';
import styles from '../styles/LoadingScreen.module.css';

/**
 * Full page loading screen
 * @returns {JSX.Element}
 */
const LoadingScreen = () => {
  return (
    <div className={styles.container}>
      <Loader text="Loading" />
    </div>
  );
};

export default LoadingScreen;
